import { Input } from '@mantine/core';
import React, { useMemo } from 'react';

import { useIsXs } from '../misc/hooks';

const labelBaseStyle = {
  textWrap: 'balance',
};

const InputWrapperAutowrap = (props) => {
  const { children, disableWrap, ...rest } = props;

  const isXs = useIsXs();

  const styles = useMemo(
    () =>
      isXs || disableWrap
        ? {
            root: {
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'flex-end',
            },
            label: labelBaseStyle,
          }
        : {
            root: {
              display: 'grid',
              gridTemplateColumns: 'minmax(200px, 250px) minmax(150px, 1fr)',
              alignItems: 'center',
              gap: '5px',
            },
            label: { margin: 0, ...labelBaseStyle },
          },
    [isXs, disableWrap],
  );

  return (
    <Input.Wrapper styles={styles} {...rest}>
      {children}
    </Input.Wrapper>
  );
};

InputWrapperAutowrap.propTypes = Input.Wrapper.propTypes;

export default InputWrapperAutowrap;
